import React, { useState, useEffect } from 'react';
import './BadgeManagerPage.css'; // Optional: for custom animations
import api from '../api/axiosConfig';

const BadgeManagerPage = () => {
    const [badges, setBadges] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    // Form State
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        imageUrl: '',
        badgeType: 'COMPLETION',
        threshold: 1
    });

    useEffect(() => {
        fetchBadges();
    }, []);

    const fetchBadges = async () => {
        try {
            const res = await api.get('/badges'); // Replace with your actual endpoint
            setBadges(res.data);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching badges:", err);
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'threshold' ? parseInt(value) : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/badges', formData);
            setIsModalOpen(false);
            setFormData({ name: '', description: '', imageUrl: '', badgeType: 'COMPLETION', threshold: 1 });
            fetchBadges();
        } catch (err) {
            alert("Failed to save badge. Check console for details.");
        }
    };

    const deleteBadge = async (id) => {
        if (window.confirm("Are you sure you want to delete this badge?")) {
            try {
                await api.delete(`/badges/${id}`);
                fetchBadges();
            } catch (err) {
                alert("Error deleting badge");
            }
        }
    };

    if (loading) return <div className="loader">Loading Mission Control...</div>;

    return (
        <div className="badge-manager-container">
            {/* Header Section */}
            <header className="admin-header">
                <div className="header-titles">
                    <h1>Badge Management System</h1>
                    <p>Configure milestones for the Space Exploration curriculum</p>
                </div>
                <button className="add-badge-btn" onClick={() => setIsModalOpen(true)}>
                    + Create New Badge
                </button>
            </header>

            {/* Stats Overview */}
            <div className="admin-stats-bar">
                <div className="stat-pill">Total Badges: {badges.length}</div>
                <div className="stat-pill">Completion Type: {badges.filter(b => b.badgeType === 'COMPLETION').length}</div>
                <div className="stat-pill">Mastery Type: {badges.filter(b => b.badgeType === 'MASTERY').length}</div>
                <div className="stat-pill">Feat Type: {badges.filter(b => b.badgeType === 'FEAT').length}</div>
                <div className="stat-pill">Streak Type: {badges.filter(b => b.badgeType === 'STREAK').length}</div>
            </div>

            {/* Badges Table */}
            <div className="table-card">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Icon</th>
                            <th>Badge Name</th>
                            <th>Description</th>
                            <th>Type</th>
                            <th>Threshold</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {badges.map((badge) => (
                            <tr key={badge.id}>
                                <td className="icon-cell">
                                    <div className="icon-preview-bg">
                                        <img src={badge.imageUrl} alt={badge.name} />
                                    </div>
                                </td>
                                <td className="name-cell">{badge.name}</td>
                                <td className="desc-cell">{badge.description}</td>
                                <td>
                                    <span className={`badge-tag ${badge.badgeType.toLowerCase()}`}>
                                        {badge.badgeType}
                                    </span>
                                </td>
                                <td className="threshold-cell">{badge.threshold}</td>
                                <td className="actions-cell">
                                    <button className="delete-btn" onClick={() => deleteBadge(badge.id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modal Overlay */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>New Achievement Milestone</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Badge Name</label>
                                <input name="name" required value={formData.name} onChange={handleInputChange} placeholder="e.g. Mars Rover" />
                            </div>
                            
                            <div className="form-group">
                                <label>Description</label>
                                <textarea name="description" value={formData.description} onChange={handleInputChange} placeholder="What must the student do?" />
                            </div>

                            <div className="form-group">
                                <label>Icon Path / URL</label>
                                <input name="imageUrl" required value={formData.imageUrl} onChange={handleInputChange} placeholder="/assets/badges/rocket.svg" />
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Reward Type</label>
                                    <select name="badgeType" value={formData.badgeType} onChange={handleInputChange}>
                                        <option value="COMPLETION">Completion</option>
                                        <option value="MASTERY">Mastery</option>
                                        <option value="FEAT">Feat</option>
                                        <option value="STREAK">Streak</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Threshold</label>
                                    <input type="number" name="threshold" value={formData.threshold} onChange={handleInputChange} min="1" />
                                </div>
                            </div>

                            <div className="modal-actions">
                                <button type="button" className="cancel-btn" onClick={() => setIsModalOpen(false)}>Cancel</button>
                                <button type="submit" className="save-btn">Save Mission Badge</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BadgeManagerPage;